import { quickStats } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="top" className="bg-background-50">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="pt-14 pb-10 md:pt-24 md:pb-14">
          {/* sparse, editorial headline block */}
          <div className="flex max-w-3xl flex-col gap-6">
            <div className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600"></span>
              </span>
              <span className="text-xs font-semibold tracking-wide text-primary-700">
                吃瓜情报 · 持续更新中
              </span>
            </div>

            <h1 className="font-display text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-5xl md:leading-[1.18]">
              九色黑料<span className="text-primary-600">爆料</span>与
              <br />
              新进展，都在首页摆给你看
            </h1>

            <p className="max-w-2xl text-base leading-relaxed text-foreground-600 md:text-lg">
              九色黑料新进展和九色黑料爆料都在这一屏持续滚动：人物、商业、作品三条主线并列清晰，
              谁在反转、谁在补锤、谁已画句号，扫一眼时间线就心中有数。吃瓜网友不用来回翻旧帖，
              按一下刷新，就能看到九色黑料最新变化。
            </p>

            <div className="flex flex-wrap items-center gap-3">
              <a
                href="#timeline"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                去刷最新进展
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
              <a
                href="#board"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
              >
                打开追踪事件榜
              </a>
              <a
                href="#channels"
                className="group inline-flex items-center gap-2 whitespace-nowrap px-2 py-3 text-sm font-medium text-foreground-700 transition-colors hover:text-primary-700"
              >
                想先逛分舱？
                <i className="ri-arrow-down-line text-sm transition-transform group-hover:translate-y-0.5"></i>
              </a>
            </div>
          </div>

          {/* a slim note to set the "按刷新更新" tone */}
          <div className="mt-8 flex items-center gap-2 text-xs text-secondary-600">
            <i className="ri-loader-3-line text-sm animate-spin"></i>
            <span>最近一次同步：刚刚 · 平均 8 分钟一条新料</span>
          </div>
        </div>

        {/* density boundary — thin stats strip under the sparse hero */}
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200 lg:grid-cols-4">
          {quickStats.map((stat, idx) => (
            <div
              key={stat.label}
              className={`flex items-center justify-between gap-3 bg-background-50 px-5 py-4 md:px-6 md:py-5 ${
                idx === 1 ? "bg-secondary-50" : ""
              }`}
            >
              <span className="whitespace-nowrap text-xs text-secondary-700 md:text-sm">
                {stat.label}
              </span>
              <span
                className={`font-display text-lg font-extrabold whitespace-nowrap md:text-2xl ${
                  idx === 1 ? "text-accent-700" : "text-foreground-950"
                }`}
              >
                {stat.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}